import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { useMediaQuery, useTheme } from '@material-ui/core'
import PageMetaData from '@v4/utils/data/PageMetaData'
import useStyles from './Content2.styled'

export const useContent2 = props => {
	const { metaData } = props

	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	const classes = useStyles(props)
	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaData.buttonText })
	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.image })
	const { handleFocus: handleMobileImageClick } = useFieldFocus({ metaData: metaData.mobileImage })
	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleTopTextClick } = useFieldFocus({ metaData: metaData.topText })

	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})
	const { editable: topTextEditable, handleChange: handleTopTextChange } = useEditorMeta({
		metaData: metaData.topText,
		key: 'topText',
	})

	const { editable: buttonTextEditable, handleChange: handleButtonTextChange } = useEditorMeta({
		metaData: metaData.buttonText,
		key: 'buttonText',
	})

	const isMobileImage = isMobile && !!metaData.mobileImage?.image

	const image = isMobileImage ? metaData.mobileImage : metaData.image

	const isImageExist = !!image?.image

	const isBackground = metaData.mobileImagePosition?.isBackgroundImage
	const isCenter = isMobile && metaData.mobileImagePosition?.isCenterImage

	return [
		{
			classes,
			direction: isMobile
				? metaData.mobileImagePosition?.contentDirection(PageMetaData.ALIGNMENT.LEFT)
				: metaData.imagePosition?.contentDirection(),
			image,
			withImage: isMobile ? !isBackground && !isCenter && isImageExist : isImageExist,
			withBgImage: isMobile ? isBackground && isImageExist : null,
			withCenterImage: isCenter && isImageExist,
			isMobile,

			text: metaData.text?.metaValue,
			textKey: metaData.text?.tierKey,
			textConfig: metaData.text?.config,
			textEditable,

			topText: metaData.topText?.metaValue,
			topTextConfig: metaData.topText?.config,
			topTextKey: metaData.topText?.tierKey,
			topTextEditable,

			buttonAction: metaData.buttonAction?.metaValue,
			buttonLink: metaData.buttonLink?.metaValue,
			buttonText: metaData.buttonText?.metaValue,
			buttonTextConfig: metaData.buttonText?.config,
			buttonTextKey: metaData.buttonText?.tierKey,
			buttonTextEditable,
		},
		{
			handleImageClick: isMobile ? handleMobileImageClick : handleImageClick,

			handleButtonClick,
			handleTextClick,
			handleTopTextClick,
			handleTextChange,
			handleTopTextChange,
			handleButtonTextChange,
		},
	]
}
